import { ErrorApi } from './errores'

/**
 * Texto para el operador a partir de un error de la API. Los códigos del
 * contrato de la spec 002 llevan una frase propia que dice qué hacer; el resto
 * usa el `mensaje` que manda el backend, que ya viene en castellano.
 */
const POR_CODIGO: Record<string, string> = {
  email_duplicado: 'Ya hay un usuario con ese correo.',
  ultimo_admin: 'No se puede: es el último administrador activo. Nombra antes a otro administrador.',
  password_debil: 'La contraseña es demasiado débil: usa una más larga.',
  producto_duplicado: 'Ya hay un producto activo con ese nombre.',
  albaran_ya_anulado: 'Ese albarán ya estaba anulado.',
  geocodificacion_desactivada:
    'La geocodificación está desactivada en Ajustes. Escribe la latitud y la longitud a mano en la ficha del cliente.',
  geocodificacion_sin_respuesta:
    'El servicio de geocodificación no ha respondido en 10 segundos. Prueba más tarde o escribe las coordenadas a mano.',
  solo_admin: 'Esta operación es solo para administradores.',
  auto_degradacion: 'No puedes quitarte a ti mismo el rol de administrador. Pídeselo a otro administrador.',
  usuario_no_encontrado: 'Ese usuario ya no existe. Recarga la lista.',
  coordenadas_incompletas: 'Escribe la latitud y la longitud juntas, o deja las dos vacías.',
  sin_hueco_etiquetas: 'Este cliente ya tiene las 12 etiquetas ocupadas: quita alguna antes de añadir ruta, semana o gran empresa.',
  semana_invalida: 'La semana del ciclo tiene que ser de s1 a s4.',
}

const GENERICO = 'No se ha podido completar la operación. Inténtalo de nuevo.'

export function mensajeDeError(error: unknown): string {
  if (!(error instanceof ErrorApi)) return GENERICO
  const propio = POR_CODIGO[error.codigo]
  if (propio) return propio
  if (error.estado === 403) return POR_CODIGO.solo_admin
  return error.mensaje || GENERICO
}
